import { ChannelkartNetworkDelete, ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from "../../services/networkService";

export async function getGlobalFilters(filterName: string, clientConfigRef?: any[]) {
    try {
        const metaData = clientConfigRef ? clientConfigRef : (await ChannelkartNetworkGet("/metadata/clientconfig"));
        const globalFilterData = (metaData?.data?.features || metaData)?.find((feature: { domainType: string }) => feature.domainType === "global_filter_configuration");

        if (globalFilterData) {
            const requiredFilterData = globalFilterData.domainValues?.find((filter: any) => filter.name === filterName);
            const filterData = requiredFilterData?.value?.filter((filter: any) => filter.id !== "outletClass");
            return filterData ?? [];
        } else {
            return [];
        }
    } catch (error) {
        console.log(error)
        return [];
    }
}

export async function getFeatureMetadata() {
    try {
        const metaData = (await ChannelkartNetworkGet("/v1/featuremetadata"));
        return metaData?.data || {};
    } catch (error) {
        console.log(error)
        return [];
    }
}

export async function createFeatureMetadata(requestBody: Record<string, any>) {
    try {
        const metaData = (await ChannelkartNetworkPost("/v1/featuremetadata", requestBody));
        return metaData;
    } catch (error) {
        console.log(error)
        return [];
    }
}

export async function getFeatureDataForId(id: string | null) {
    try {
        const metaData = (await ChannelkartNetworkGet(`/v1/featuremetadata?filter=id:${id}`));
        return metaData.data;
    } catch (error) {
        console.log(error)
        return [];
    }
}

export async function deleteFeatureMetadata(outletId: string) {
    try {
        const response = (await ChannelkartNetworkDelete(`/v1/featuremetadata?id=${outletId}`));
        return response.status;
    } catch (error) {
        console.log(error)
        return [];
    }
}

export async function updateFeatureMetadata(name: string, requestBody: Record<string, any>) {
    try {
        const metaData = (await ChannelkartNetworkPut(`/v1/featuremetadata/${name}`, requestBody));
        return metaData.status;
    } catch (error) {
        console.log(error)
        return [];
    }
}